<template>
  <el-dialog :visible="show" title="新增场景（作品暂无场景，需先上传场景图片）" width="770px" append-to-body @close="closeDialog">
    <el-form label-width="100px" ref="vForm" size="medium">
      <el-form-item label="全景图片">
        <vr-upload
          :loading.sync="doSubmitLoading"
          :map="true"
          @success="
            (images) => {
              keys = images;
            }
          "
        />
        <div class="v-form-tips">请上传2:1的全景图片，例如：宽6000px，高3000px，拖拽可以进行排序</div>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="closeDialog" size="small">关闭</el-button>
      <el-button type="primary" @click="doSubmit" :loading="doSubmitLoading" size="small">确 定</el-button>
    </div>
  </el-dialog>
</template>

<script>
import vrUpload from './vr-upload';

export default {
  props: ['show', 'row'],

  components: { vrUpload },

  data() {
    return {
      doSubmitLoading: false,
      keys: [],
    };
  },

  methods: {
    closeDialog() {
      this.$emit('update:show', false);
    },

    //提交作品
    async doSubmit() {
      if (this.keys.length == 0) {
        this.$message.error('请先上传场景图片');
        return;
      }
      this.doSubmitLoading = true;
      try {
        await this.api.works.addScene({
          works_id: this.row.id,
          group_id: this.row.group_id,
          keys: this.keys,
        });
        this.$message.success('添加成功');
        this.$emit('success', '');
        this.closeDialog();
      } catch (e) {
        console.error(e);
      }
      this.doSubmitLoading = false;
    },
  },
};
</script>

<style scoped>
.v-form-select {
  position: relative;
}
</style>
